export const mockVocabulary = [
  {
    id: '1',
    term: 'Idempotent',
    sourceUrl: 'https://developer.mozilla.org/en-US/docs/Glossary/Idempotent',
    sourceTitle: 'MDN Web Docs - Glossary',
    plainEnglish: 'An operation that produces the same result no matter how many times you run it.',
    context: 'When designing the REST API, we ensured the PUT endpoint was idempotent so retries wouldn\'t cause duplicate records.',
    spanishSummary: 'Una operación que produce el mismo resultado sin importar cuántas veces se ejecute.',
    simpleWay: 'Doing it once is the same as doing it 100 times.',
    exampleSentence: 'Because checking your bank balance is an idempotent action, you can refresh the page safely.',
    keyTerms: ['API', 'REST', 'Architecture', 'Reliability'],
    dateAdded: '2023-10-24',
    category: 'Computer Science',
    color: '#FFB5A7' // Soft Coral
  },
  {
    id: '2',
    term: 'Polymorphism',
    sourceUrl: 'https://en.wikipedia.org/wiki/Polymorphism_(computer_science)',
    sourceTitle: 'Wikipedia - Polymorphism',
    plainEnglish: 'The ability of different objects to respond to the same method call in their own unique way.',
    context: 'We used polymorphism in the payment gateway so both Stripe and PayPal classes could implement a common `.charge()` method.',
    spanishSummary: 'La capacidad de diferentes objetos para responder a la misma llamada de método a su manera única.',
    simpleWay: 'Many forms, one interface.',
    exampleSentence: 'Thanks to polymorphism, our rendering engine can draw Circles, Squares, and Triangles using just one generic loop.',
    keyTerms: ['OOP', 'Design Patterns', 'Java', 'C++'],
    dateAdded: '2023-10-25',
    category: 'Programming Concepts',
    color: '#A8E6CF' // Soft Mint
  },
  {
    id: '3',
    term: 'Memoization',
    sourceUrl: 'https://react.dev/reference/react/useMemo',
    sourceTitle: 'React Docs - useMemo',
    plainEnglish: 'An optimization technique that speeds up programs by storing the results of expensive function calls.',
    context: 'The dashboard was lagging, so we applied memoization to the data parsing function to prevent recalculations on every render.',
    spanishSummary: 'Técnica de optimización que acelera los programas almacenando los resultados de llamadas a funciones costosas.',
    simpleWay: 'Remembering the answer so you don\'t have to do the math again.',
    exampleSentence: 'By using memoization, the recursive Fibonacci function ran in milliseconds instead of minutes.',
    keyTerms: ['Performance', 'Optimization', 'React', 'Algorithms'],
    dateAdded: '2023-10-26',
    category: 'Performance',
    color: '#FFD3B6' // Soft Peach
  },
  {
    id: '4',
    term: 'Heuristic',
    sourceUrl: 'https://www.nngroup.com/articles/ten-usability-heuristics/',
    sourceTitle: 'NN/g - Usability Heuristics',
    plainEnglish: 'A mental shortcut or "rule of thumb" used for problem-solving that might not be perfect, but is practical and fast.',
    context: 'The antivirus uses a heuristic approach to detect unknown malware based on suspicious behavior patterns.',
    spanishSummary: 'Un atajo mental o "regla general" utilizado para la resolución de problemas que es práctico y rápido.',
    simpleWay: 'A good enough guess based on experience.',
    exampleSentence: 'We applied a simple heuristic to sort the search results: items updated most recently appear first.',
    keyTerms: ['UX', 'AI', 'Problem Solving', 'Psychology'],
    dateAdded: '2023-10-27',
    category: 'General Tech',
    color: '#D4A5A5' // Soft Mauve
  },
  {
    id: '5',
    term: 'Debouncing',
    sourceUrl: 'https://lodash.com/docs/4.17.15#debounce',
    sourceTitle: 'Lodash Documentation',
    plainEnglish: 'A programming practice used to ensure that time-consuming tasks do not fire so often, stalling the performance of the web page.',
    context: 'We added debouncing to the search bar so it only makes an API call after the user stops typing for 300ms.',
    spanishSummary: 'Práctica para asegurar que las tareas que consumen tiempo no se disparen con tanta frecuencia.',
    simpleWay: 'Wait until I\'m finished before you do the thing.',
    exampleSentence: 'Without debouncing, resizing the browser window caused our chart component to redraw 50 times a second.',
    keyTerms: ['Frontend', 'JavaScript', 'Performance', 'Events'],
    dateAdded: '2023-10-28',
    category: 'Frontend Engineering',
    color: '#9EA1D4' // Soft Periwinkle
  }
];